import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { NbButtonModule } from '@nebular/theme';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-generic-button-renderer',
    template: `
      <div style="display: flex; align-items: center; justify-content: center; gap: 6px; height: 100%; width: 100%;">
        <button nbButton [status]="status" (click)="handleGenericButtonClicked()" style="height: 22px; line-height: 22px; padding: 0 6px; font-size: 10px; white-space: nowrap;">{{btnText}}</button>
        <fa-icon [icon]="['fal', 'trash-can']" (click)="handleDeleteClicked()" style="cursor: pointer; color: #ff4757; font-size: 12px; padding: 4px; border-radius: 4px; transition: background-color 0.2s;" (mouseenter)="$event.target.style.backgroundColor='rgba(255, 71, 87, 0.1)'" (mouseleave)="$event.target.style.backgroundColor='transparent'"></fa-icon>
      </div>
    `,
    styles: [``],
    standalone: true,
    imports: [
      NbButtonModule,
      FontAwesomeModule
    ]
})
export class GenericButtonRendererComponent implements ICellRendererAngularComp {

  private params: any;

  btnText: string = 'DEFAULT_BTN_TEXT';

  status: 'basic' | 'primary' | 'success' | 'info' | 'warning' | 'danger' = 'basic'

  showDeleteIcon: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.btnText = params.btnText ?? this.btnText
    this.status = params.status ?? this.status
    this.showDeleteIcon = params.showDeleteIcon ?? this.showDeleteIcon
  }

  refresh(): boolean {
    return false;
  }

  public handleGenericButtonClicked(): void {
    const {data, handleGenericButtonClicked} = this.params
    if (!handleGenericButtonClicked) {
      console.error("configuration isn't set")
      return
    }
    handleGenericButtonClicked(data)
  }

  public handleDeleteClicked(): void {
    const {data, handleDeleteClicked} = this.params
    if (!handleDeleteClicked) {
      console.error("delete handler isn't set")
      return
    }
    handleDeleteClicked(data)
  }
}
